import axiosPost from '../axiosPost';
import { MerchantUsuarioType, UserCredentialsType } from '../../../types/types';
import { AxiosPostBody } from '../../../types/AxiosPost';

export const MerchantSucursalGet = async (arg: UserCredentialsType, merchantId: number, merchantSucursalId: number) => {
    const body: AxiosPostBody = {
        "service": "MerchantSucursalGet",
        "params": {
            merchantId: merchantId,
            merchantSucursalId: merchantSucursalId

        }
    }

    try {
        const result = await axiosPost<MerchantUsuarioType>('Y', body, arg);
        return result
        
    } catch (err) {
        console.log(err)
    }
}